// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useState } from 'react';
import { S } from './FaqPageStyle';

import ArrowImg from '../../assets/images/arrow.svg';
import LargeEnglishTitle from '../../components/typography/LargeEnglishTitle';
import MainLayout from '../../layouts/MainLayout';
import { TOC } from './FaqContents'
import { Link } from 'react-router-dom';

interface childrenProps {
  title: string;
  content: string;
}

interface dropdownRow {
  title: string;
  content: string;
  children: childrenProps[];
}

interface BreadcrumbProps extends React.ComponentProps<any> {
  groupIndex: number;
  childrenIndex: number;
}

function Breadcrumb({ groupIndex, childrenIndex }: BreadcrumbProps) {
  let child;
  if (TOC[groupIndex].children[groupIndex]) {
    child = (
      <>
        <S.BreadcrumbArrow src={ArrowImg} alt="arrow" />
        <S.BreadcrumbText>{TOC[groupIndex].children && TOC[groupIndex].children[childrenIndex].title}</S.BreadcrumbText>
      </>
    )
  }

  return (
    <S.BreadcrumbWrapper>
      <S.BreadcrumbText as={Link} to="/home">首頁</S.BreadcrumbText>
      <S.BreadcrumbArrow src={ArrowImg} alt="arrow" />
      <S.BreadcrumbText>{TOC[groupIndex].title}</S.BreadcrumbText>
      {child}
    </S.BreadcrumbWrapper>
  )
}

export default function () {
  const [selected, setSelected] = useState({
    groupIndex: 0,
    childrenIndex: 0,
    title: TOC[0].title,
    content: TOC[0].content
  });

  function handleClick(groupIndex: number, childrenIndex: number, title: string, content: string) {
    setSelected({
      groupIndex,
      childrenIndex,
      title,
      content,
    })
  }

  function parsedContent() {
    return { __html: selected.content.replace(/\n/g, '<br/>') }
    // return selected.content
    // .split('\n')
    // .reduce<React.ReactElement[]>((array, text, index) => {
    //   if (array.length === 0) {
    //     return array.concat([
    //       (<React.Fragment key={index}>{text}</React.Fragment>)
    //     ]);
    //   }
    //   return array.concat([
    //     (<br />),
    //     (<React.Fragment key={index}>{text}</React.Fragment>)
    //   ]);
    // }, [])
  }

  // return <div dangerouslySetInnerHTML={createMarkup()} />;

  return (
    <MainLayout>
      <S.Banner>
        <LargeEnglishTitle
          style={{ marginLeft: '23px' }}
          color="White"
          weight="Medium"
        >
          常見問題
        </LargeEnglishTitle>
      </S.Banner>
      <S.HomeWrapper>
        <S.Container>
          <Breadcrumb groupIndex={selected.groupIndex} childrenIndex={selected.childrenIndex} />
          <S.Title>{selected.title}</S.Title>
          <S.Paragraph dangerouslySetInnerHTML={parsedContent()} />
        </S.Container>
        <S.Sidebar>
          {
            // <pre>{JSON.stringify(show,null,2)}</pre>
            TOC.map((topic: dropdownRow, index: number) => {
              const groupActive = selected.groupIndex === index;
              return (
                <S.TocWrapper key={index}>
                  <S.TocTitle className={groupActive ? 'active' : ''}
                    onClick={() => handleClick(index, -1, topic.title, topic.content)}
                  >
                    {topic.title}
                    {
                      topic.children.length > 0 ?
                        (
                          <S.DropArrow src={ArrowImg} alt="arrow-img" className={groupActive ? 'active' : ''} />
                        ): null
                    }
                  </S.TocTitle>
                  {
                    topic.children.length > 0 ? (
                      <S.TocSubTitleWrapper className={groupActive ? 'active' : ''}>
                        {
                          topic.children.map((children: childrenProps, childrenIndex: number) => {
                            const itemActive = selected.childrenIndex === childrenIndex;

                            return (
                              <S.TocSubTitle
                                key={index}
                                onClick={() => handleClick(index, childrenIndex, children.title, children.content)}
                                className={groupActive && itemActive ? 'active' : ''}
                              >
                                {children.title}
                              </S.TocSubTitle>
                            )
                          })
                        // <pre>{JSON.stringify(TOC,null,2)}</pre>
                        }
                      </S.TocSubTitleWrapper>
                    ) : null
                  }

                </S.TocWrapper>
              )
            })
          }
        </S.Sidebar>
      </S.HomeWrapper>
    </MainLayout>
  );
}
